import fetch from '../utils/fetch'

export function getAftersalesList(query) {
  return fetch({
    url: '/aftersales',
    method: 'get',
    params: query
  })
}

export function exportList(query) {
  return fetch({
    url: '/aftersales/logExport',
    method: 'get',
    params: query,
  })
}

export function getAftersalesDetail(aftersalesBn) {
  return fetch({
    url: '/aftersales/' + aftersalesBn,
    method: 'get'
  })
}

export function reviewAftersales(query) {
  return fetch({
    url: '/aftersales/review',
    method: 'post',
    data: query
  })
}

export function refundCheck(query) {
  return fetch({
    url: '/aftersales/refundCheck',
    method: 'post',
    data: query
  })
}

export function sendConfirm(query) {
  return fetch({
    url: '/aftersales/sendConfirm',
    method: 'post',
    data: query
  })
}

export function editRemarks(query) {
  return fetch({
    url: '/aftersales/editremarks',
    method: 'put',
    data: query
  })
}




// WEBPACK FOOTER //
// ./src/api/aftersales.js